import React from "react";
import { Updater } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme";
import { Divider, Grid } from "@mui/material";

import theme from "../../../../theme";

interface TableHeaderProps {
  tabValue: number;
  setTabValue: Updater<number>;
}
export const TableHeader = ({ tabValue, setTabValue }: TableHeaderProps) => {
  return (
    <Grid
      item
      container
      direction={"row"}
      columnSpacing={2}
      alignItems={"center"}
    >
      <Grid item>
        <IgTypography
          igStyle={"semibold"}
          sx={{ fontSize: "20px", textTransform: "uppercase" }}
        >
          Compare Audiences
        </IgTypography>
      </Grid>
      <Grid item>
        <Divider sx={{ height: "24px" }} orientation={"vertical"} />
      </Grid>
      <Grid item>
        <IgTypography
          onClick={() => {
            setTabValue(0);
          }}
          sx={{
            fontSize: "15px",
            color: tabValue === 0 ? theme.palette.primary.main : "#494C50",
            "&:hover": {
              cursor: tabValue !== 0 ? "pointer" : "default",
              color: theme.palette.primary.main,
            },
          }}
        >
          All Visitors
        </IgTypography>
      </Grid>
      <Grid item>
        <Divider sx={{ height: "24px" }} orientation={"vertical"} />
      </Grid>
      <Grid item>
        <IgTypography
          onClick={() => {
            setTabValue(1);
          }}
          sx={{
            fontSize: "15px",
            color: tabValue === 1 ? theme.palette.primary.main : "#494C50",
            "&:hover": {
              cursor: tabValue !== 1 ? "pointer" : "default",
              color: theme.palette.primary.main,
            },
          }}
        >
          Desktop / Mobile
        </IgTypography>
      </Grid>
      <Grid item>
        <Divider sx={{ height: "24px" }} orientation={"vertical"} />
      </Grid>
      <Grid item>
        <IgTypography
          onClick={() => {
            setTabValue(2);
          }}
          sx={{
            fontSize: "15px",
            color: tabValue === 2 ? theme.palette.primary.main : "#494C50",
            "&:hover": {
              cursor: tabValue !== 2 ? "pointer" : "default",
              color: theme.palette.primary.main,
            },
          }}
        >
          New / Returning
        </IgTypography>
      </Grid>
      <Grid item>
        <Divider sx={{ height: "24px" }} orientation={"vertical"} />
      </Grid>
      <Grid item>
        <IgTypography
          onClick={() => {
            setTabValue(4);
          }}
          sx={{
            fontSize: "15px",
            color: tabValue === 4 ? theme.palette.primary.main : "#494C50",
            "&:hover": {
              cursor: tabValue !== 4 ? "pointer" : "default",
              color: theme.palette.primary.main,
            },
          }}
        >
          Channel
        </IgTypography>
      </Grid>
      <Grid item>
        <Divider sx={{ height: "24px" }} orientation={"vertical"} />
      </Grid>
      <Grid item>
        <IgTypography
          onClick={() => {
            setTabValue(3);
          }}
          sx={{
            fontSize: "15px",
            color: tabValue === 3 ? theme.palette.primary.main : "#494C50",
            "&:hover": {
              cursor: tabValue !== 3 ? "pointer" : "default",
              color: theme.palette.primary.main,
            },
          }}
        >
          Traffic Source
        </IgTypography>
      </Grid>
    </Grid>
  );
};
